import {
  ACCOUNT_SETUP_REQUEST,
  ACCOUNT_SETUP_SUCCESS,
  ACCOUNT_SETUP_FAILURE,
  RESET_ACCOUNT_SETUP_STATE,
} from "../../actionTypes/accountSetup";

interface AccountSetupState {
  isLoading: boolean;
  isProcessIntiated: boolean;
  error: string | null;
  success: boolean;
}

const initialState: AccountSetupState = {
  isLoading: false,
  isProcessIntiated: false,
  error: null,
  success: false,
};

interface AccountSetupAction {
  type: string;
  payload?: any;
}

const accountSetupReducer = (
  state = initialState,
  action: AccountSetupAction
): AccountSetupState => {
  switch (action.type) {
    case ACCOUNT_SETUP_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        success: false,
        isProcessIntiated: false,
      };
    case ACCOUNT_SETUP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isProcessIntiated: true,
        success: true,
        error: null,
      };
    case ACCOUNT_SETUP_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload || "Account setup failed. Please try again.",
        success: false,
        isProcessIntiated: false,
      };
    case RESET_ACCOUNT_SETUP_STATE:
      return initialState;
    default:
      return state;
  }
};

export default accountSetupReducer;

